export default __webpack_public_path__ + "static/hackster-509392a99eb1c7f634c69032980d627d.svg";